<div class="container-idle" [class.show]="">
	<div class="modal" tabindex="-1">
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-body">
					<div class="success-checkmark">
						<div class="check-icon">
						  <span class="icon-line line-tip"></span>
						  <span class="icon-line line-long"></span>
						  <div class="icon-circle"></div>
						  <div class="icon-fix"></div>
						</div>
					  </div>
					  <h1>{{message}}</h1>
				</div>
			</div>
		</div>
	</div>
</div>